import { Modal, Text, Group, Box, Stack } from 'components'
import { IconSparkles } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { AIGeneratorModalProps } from './interfaces'
import { useAIGeneratorModal } from './hooks/useAIGeneratorModal'
import { AILoadingState } from './components/AILoadingState'
import { AIGeneratorForm } from './components/AIGeneratorForm'

export function AIGeneratorModal(props: AIGeneratorModalProps) {
  const { opened, onClose } = props
  const { t } = useTranslation()

  const {
    selectedSchoolTermId,
    selectedGroupId,
    description,
    schoolTermsData,
    groupsData,
    loadingGroups,
    generating,
    generatingMessage,
    generatingProgress,
    setSelectedGroupId,
    setDescription,
    handleSchoolTermChange,
    handleGenerate,
    handleClose,
  } = useAIGeneratorModal(props)

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      centered
      title={
        <Group spacing='xs'>
          <IconSparkles size={24} style={{ color: '#8b5cf6' }} />
          <Text size='lg' weight={600}>{t('new_project_page.ai_modal_title')}</Text>
        </Group>
      }
      size='lg'
    >
      <Stack spacing='lg'>
        {generating ? (
          <Box style={{ position: 'relative', minHeight: '400px' }}>
            <AILoadingState
              message={generatingMessage}
              progress={generatingProgress}
            />
          </Box>
        ) : (
          <>
            <Group spacing='xs' align='center' noWrap>
              <IconSparkles size={20} style={{ color: '#8b5cf6' }} />
              <Text size='md' weight={500} color='dimmed'>
                {t('new_project_page.ai_modal_subtitle')}
              </Text>
            </Group>

            <AIGeneratorForm
              selectedSchoolTermId={selectedSchoolTermId}
              selectedGroupId={selectedGroupId}
              description={description}
              schoolTermsData={schoolTermsData}
              groupsData={groupsData}
              loadingGroups={loadingGroups}
              generating={generating}
              onSchoolTermChange={handleSchoolTermChange}
              onGroupChange={setSelectedGroupId}
              onDescriptionChange={setDescription}
              onGenerate={handleGenerate}
              onCancel={handleClose}
            />
          </>
        )}
      </Stack>
    </Modal>
  )
}